import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { EmissionReducingAdditive } from '~/api/services/climaCheck'
import { FormFields } from '~/components/FormFields'

interface Props {
  emissionReducingAdditives: EmissionReducingAdditive[]
}

const FourteenStep:React.FC<Props> = ({ emissionReducingAdditives }) => {
  const { control, setValue } = useFormContext()

  const watchEmissionCheck = useWatch({ control, name: 'usingEmissionReducingAdditives' })
  const watchEmissionAdditives = useWatch({ control, name: 'emissionReducingAdditives' }) || []

  function renderEmissionReducingSelect() {
    return <FormFields.Select
      control={control}
      multiple
      label={'Maßnahme zur Emissionsminderung'}
      withoutAsterisk
      rules={{
        required: true
      }}
      noErrorMessage
      style={{ width: '50%' }}
      value={watchEmissionAdditives.map(item => item.id)}
      placeholder='Bitte Maßnahme auswählen'
      name='emissionReducingAdditives'
      selectOnBlur={false}
      options={emissionReducingAdditives?.map(item => ({ text: item.label, value: item.id }))}
      onChange={(e, data ) => {
        const selectedArray = data.value as number[]
        setValue('emissionReducingAdditives', emissionReducingAdditives.filter(item => selectedArray.find(emission => emission === item.id)))
      }}
    />
  }

  function renderAnswerTextArea() {
    return <FormFields.TextArea
      control={control}
      rules={{
        required: true
      }}
      noErrorMessage
      name={`emissionReducingAdditives[${indexAnswerTextArea}].answer`}
      placeholder={'Bitte Maßnahme beschreiben'}
      label={'Weitere Maßnahme'}
    />
  }

  const indexAnswerTextArea = watchEmissionAdditives.findIndex(item => item.hasTextAnswer === 1)

  return <>
    <FormFields.Checkbox
      control={control}
      name={'usingEmissionReducingAdditives'}
      defaultValue={0}
      checkboxValue={1}
      label={'Verwenden Sie emissionsmindernde Zusatzstoffe?'}
    />
    {Boolean(watchEmissionCheck) && renderEmissionReducingSelect()}
    {indexAnswerTextArea >= 0 && renderAnswerTextArea()}
  </>
}
export default FourteenStep